// src/utils/logger.js
export async function logEvent(eventType, message, details = {}) {
  try {
    await fetch('/api/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        message,
        details,
        timestamp: new Date().toISOString()
      })
    });
  } catch (error) {
    // Gerekirse burada localStorage'a da yazabilirsiniz
    console.error('Log gönderilemedi:', error);
  }
}
